import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { ProviderConnectionStatus, forHumans } from "@madmedical/medical";
import { formatDateTime } from "@madmedical/utils";
import { Text } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import { useRouteNavigate } from "../providers/routing";
import ReactTable from "../molecules/ReactTable";
import Tag from "../atoms/Tag";
import AvatarTexts from "../molecules/AvatarTexts";
import { useDevices } from "../providers/device";
import getImage from "./DeviceItem/getImage";
const MAX_TAGS = 3;
const ConnectedDevicesTable = () => {
    const { devices } = useDevices();
    const navigate = useRouteNavigate();
    const { t } = useTranslation();
    const columns = useMemo(() => [
        {
            Header: t("deviceName"),
            accessor: "provider",
            defaultCanSort: true,
            width: "25%",
            Cell: ({ row: { original: device } }) => (_jsx(AvatarTexts, { size: "xl", isCircle: false, source: getImage(device.provider), label: device.deviceName, subText: t(`backend:${device.manufacturer}`), status: device.status === ProviderConnectionStatus.Off
                    ? undefined
                    : device.status })),
        },
        {
            Header: t("measures:type"),
            accessor: "metricTypes",
            width: "auto",
            Cell: ({ value: metricTypes }) => {
                const count = metricTypes.length;
                if (!count) {
                    return _jsx(Text, { children: "–" });
                }
                const types = metricTypes.slice(0, MAX_TAGS);
                const remains = count - types.length;
                return (_jsxs(_Fragment, { children: [types.map((metricType) => (_jsx(Tag, Object.assign({ mr: 2 }, { children: t(`measures:${forHumans(metricType)}`) }), metricType))), remains ? (_jsxs(Tag, Object.assign({ mr: 2 }, { children: ["+", remains] }), remains)) : null] }));
            },
        },
        {
            Header: t("measures:lastRecord"),
            accessor: "lastRecordedAt",
            width: "20%",
            defaultCanSort: true,
            sortType: (a, b) => b.values.lastRecordedAt - a.values.lastRecordedAt,
            Cell: ({ value: lastRecordedAt }) => (_jsx(_Fragment, { children: lastRecordedAt ? formatDateTime(lastRecordedAt) : "-" })),
        },
    ], [t]);
    const handlePress = ({ provider }) => {
        navigate("device", { provider });
    };
    return (_jsx(ReactTable, { columns: columns, data: devices, onPress: handlePress }));
};
export default ConnectedDevicesTable;
